(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["colageasimetrico"] && !Shopify.designMode) return;
  try {
    
/* === ANIMACIÓN MEJORADA CON INTERSECTION OBSERVER === */
class CollageAnimator {
  constructor() {
    this.section = document.querySelector('#collage-scroll');
    this.image1 = this.section?.querySelector('.collage-item-1');
    this.header = document.querySelector('.header-wrapper, sticky-header');
    this.headerHeight = this.header ? this.header.offsetHeight : 100;
    this.lastScrollTop = 0;
    this.revealActive = false;
    
    if (this.section && this.image1) {
      this.init();
    }
  }
  
  init() {
    // Usar Intersection Observer para mejor performance
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.section.classList.add('scrolled');
            this.handleReveal(entry.boundingClientRect);
          } else {
            this.handleRevealExit();
          }
        });
      },
      {
        threshold: [0, 0.1, 0.5, 1],
        rootMargin: `-${this.headerHeight + 50}px 0px 0px 0px`
      }
    );
    
    this.observer.observe(this.section);
    
    // Scroll listener para comportamiento adicional
    document.addEventListener('scroll', this.throttle(this.handleScroll.bind(this), 16));
  }
  
  handleReveal(rect) {
    const windowHeight = window.innerHeight;
    const triggerPoint = windowHeight * 0.3;
    
    if (rect.top < triggerPoint && rect.top > this.headerHeight + 80 && !this.revealActive) {
      this.activateReveal();
    } else if (rect.top <= this.headerHeight + 50 && this.revealActive) {
      this.deactivateReveal();
    }
  }
  
  handleRevealExit() {
    if (this.revealActive) {
      this.deactivateReveal();
    }
  }
  
  handleScroll() {
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const rect = this.section.getBoundingClientRect();
    
    // Scroll rápido hacia arriba - desactivar reveal
    if (currentScrollTop < this.lastScrollTop - 30 && this.revealActive) {
      if (rect.top < this.headerHeight + 100) {
        this.deactivateReveal();
      }
    }
    
    this.lastScrollTop = currentScrollTop;
  }
  
  activateReveal() {
    this.image1.classList.add('reveal-active');
    this.revealActive = true;
    
    // Efecto sutil de borde navideño
    this.image1.style.borderColor = 'rgba(55, 190, 176, 0.5)';
  }
  
  deactivateReveal() {
    this.image1.classList.remove('reveal-active');
    this.image1.classList.add('reveal-return', 'reveal-done');
    this.revealActive = false;
    
    // Restaurar borde normal
    setTimeout(() => {
      this.image1.style.borderColor = '';
    }, 1200);
  }
  
  throttle(func, limit) {
    let inThrottle;
    return function() {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    }
  }
}

// Inicializar cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', () => {
  new CollageAnimator();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
